import Box from "@mui/material/Box";
import useIsCreate from "hooks/useIsCreate";
import { useParams } from "react-router-dom";
import { useTrialHeaderQuery } from "@generated/graphql";
import CircularLoading from "components/CircularLoading";
import PersonalHeader from "./components/Header";
import TestingContent from "./components/Content";

const TestingView = () => {
  const isCreate = useIsCreate();
  const { id } = useParams();

  const { data, loading } = useTrialHeaderQuery({
    variables: {
      trialId: id!,
    },
    skip: !id,
  });

  if (loading) return <CircularLoading />;

  return (
    <Box>
      <PersonalHeader trial={data?.trial} />
      <TestingContent
        trial={data?.trial}
        isCreate={isCreate}
      />
    </Box>
  );
};
export default TestingView;
